// extracted by mini-css-extract-plugin
export default {"text_area_container":"CustomTextArea_text_area_container__2B+56","text_area_label":"CustomTextArea_text_area_label__YjLpq","text_area":"CustomTextArea_text_area__LYINJ"};